<template>
  <div class="content">
    <div @click="$emit('click',{})" class="container">
      <strong class="text">No hay información</strong>
      <i class="fa fa-refresh icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Empty"
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container {
  background-color: #fb8e2c;
  border-radius: 16px;
  padding: 8px;
  margin-top: 8px;
  margin-bottom: 4px;
  width: 200px;
  min-height: 62.5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.text {
  font-family: "Roboto-Bold";
  font-size: 25px;
  color: #fff;
  text-align: center;
}
.icon{
    color: #fff;
    font-size: 35px;
}
</style>
